// store.ts
import { configureStore } from "@reduxjs/toolkit";
import authReducer, { logout } from "../redux/slices/authSlice";
import phoneReducer from '../redux/slices/phoneSlice';
import profileReducer from '../redux/slices/profileSlice';

const persistedAuth = localStorage.getItem("authState")
  ? JSON.parse(localStorage.getItem("authState")!)
  : undefined;

export const store = configureStore({
  reducer: {
    auth: authReducer,
    phone: phoneReducer,
    profile: profileReducer
  },
  
  preloadedState: {
    auth: persistedAuth,
  },
  devTools: false
});

store.subscribe(() => {
  const state = store.getState();

  if (!state.auth.isLoggedIn) {
    localStorage.removeItem("authState");
  } else {
    localStorage.setItem("authState", JSON.stringify(state.auth));
  }
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
